// Optimized and Responsive MarketData Component
import { useState } from "react";
import { useSelector } from "react-redux";
import Details from "./market-data/Details";
import Graph from "./market-data/Graph";
import OptionsTimeSales from "./market-data/OptionsTimeSales";
import TradeFlash from "./market-data/TradeFlash";

const TAB_ITEMS = [
  { id: "details", label: "Details" },
  { id: "graph", label: "Graph" },
  { id: "options-time-sales", label: "Options Time & Sales" },
  { id: "trade-flash", label: "Trade Flash" },
];

const panelVisibility = (activeTab, tabId) =>
  `flex min-h-0 flex-1 flex-col overflow-hidden ${activeTab === tabId ? "" : "hidden"}`;

const MarketData = () => {
  const { theme } = useSelector((state) => state.theme);
  const [activeTab, setActiveTab] = useState("details");
  /** Each Market Data tab keeps its own ticker selection. */
  const [selectedByTab, setSelectedByTab] = useState({
    details: null,
    graph: null,
    "options-time-sales": null,
    "trade-flash": null,
  });

  const setTabSelected = (tabId) => (value) => {
    setSelectedByTab((prev) => ({ ...prev, [tabId]: value }));
  };

  return (
    <div className={`relative flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden overflow-y-hidden ${theme === 'dark' ? 'bg-[#0f172a] text-slate-200' : 'bg-slate-50 text-slate-900'}`}>
      <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
        <div className="shrink-0 p-3 sm:p-5 pb-0">
          <div className="flex flex-nowrap items-center gap-1.5 p-1 rounded-2xl bg-slate-200/50 dark:bg-slate-800/50 backdrop-blur-sm w-full overflow-x-auto scrollbar-hide">
            {TAB_ITEMS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 min-w-fit px-3 sm:px-4 py-2 sm:py-2.5 rounded-xl text-[10px] xs:text-xs sm:text-sm font-bold whitespace-nowrap transition-all duration-300 ease-out ${
                  activeTab === tab.id
                    ? theme === 'dark'
                      ? "bg-blue-600 text-white shadow-lg shadow-blue-900/20"
                      : "bg-white text-blue-600 shadow-md shadow-slate-200"
                    : theme === 'dark'
                      ? "text-slate-400 hover:text-slate-200 hover:bg-slate-800"
                      : "text-slate-500 hover:text-slate-700 hover:bg-slate-100"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden p-0">
          <div className={`relative flex min-h-0 flex-1 flex-col overflow-hidden transition-all duration-500 ${
            theme === 'dark'
              ? 'bg-slate-900/40 border border-slate-800 shadow-2xl'
              : 'bg-white border border-slate-200 shadow-xl'
          }`}>
            <div className={panelVisibility(activeTab, "details")}>
              <Details
                selected={selectedByTab.details}
                setSelected={setTabSelected("details")}
                isActive={activeTab === "details"}
              />
            </div>
            <div className={panelVisibility(activeTab, "graph")}>
              <Graph
                selected={selectedByTab.graph}
                setSelected={setTabSelected("graph")}
              />
            </div>
            <div className={panelVisibility(activeTab, "options-time-sales")}>
              <OptionsTimeSales
                selected={selectedByTab["options-time-sales"]}
                setSelected={setTabSelected("options-time-sales")}
                isActive={activeTab === "options-time-sales"}
              />
            </div>
            <div className={panelVisibility(activeTab, "trade-flash")}>
              <TradeFlash
                selected={selectedByTab["trade-flash"]}
                setSelected={setTabSelected("trade-flash")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketData;
